import { Outlet } from "react-router-dom"





const Finances = () => {

    return (
        <div>
            <Outlet />
        </div>
    )
}

export default Finances;